export enum Role {
  MASTER = 'master',
  SUPERUSER = 'superuser',
  EDITAR_PROJETO = 'editar-projeto',
  EDITAR_REPOSITORIO = 'editar-repositorio',
  FORESTOKEN = 'forestoken',
  FORESTCLOUD_USER = 'forestcloud_user',
  FORESTCLOUD_MASTER = 'forestcloud_master',
}

export type AppRoles = Role[];
